import _swal from "sweetalert2";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import {BotKimligi} from "@/store/modules/imzaKimligi";

/**
 * Büro değiştirirken bot uyarısı (DEV-3903).
 *
 * Bot, görevi alırken aktif kimliğini (büro + avukat) sabitler: büro değişimi kendiliğinden
 * botu başka büroya geçirmez, çalışan görevler eski büro adına biter. Kullanıcı bunu
 * bilmeden büro değiştirirse kendi bürosunun görevlerinin neden başlamadığını anlayamaz;
 * bu yüzden bot meşgulken değişimden önce açıkça uyarılır.
 */

/** Bot bir şey işliyor ya da işlemeye hazır mı? (dur: bot beklemede, değişim güvenli.) */
export function botMesgulMu(girdi: { playerDurum: any, gorevler: any, botKimligi: BotKimligi | null }): boolean {
    if (girdi.playerDurum === PlayerDurum.dur) return false;
    // İmzacıda "Geç" bekleyen bir kimlik geçişi var: bot şu an eski kimlikle çalışıyor.
    if (girdi.botKimligi && girdi.botKimligi.bekleyenGecis) return true;
    const liste = girdi.gorevler && Array.isArray(girdi.gorevler.incomplete_tasks) ? girdi.gorevler.incomplete_tasks : [];
    return liste.some((gorev: any) => gorev && (gorev.status === TaskDurum.SIRADA
        || gorev.status === TaskDurum.ISLENIYOR || gorev.status === TaskDurum.BEKLEMEDE));
}

export function buroDegistirmeUyarisi(girdi: { botKimligi: BotKimligi | null, hedefBuro: string }): { baslik: string, metin: string } {
    const kimlik = girdi.botKimligi;
    let giris = "Bot şu anda görev işliyor.";
    if (kimlik && kimlik.buro) {
        giris = "Bot " + kimlik.buro + " bürosu adına" + (kimlik.avukat ? " (Av. " + kimlik.avukat + ")" : "") + " görev işliyor.";
    }
    const metin = giris + " Büro değiştirseniz bile bot çalıştığı görevleri bu büro adına bitirir; \"" + girdi.hedefBuro +
        "\" bürosunun görevleri ancak bunlar bittikten sonra başlar. Farklı bir avukatın hesabına geçiyorsanız bot, " +
        "imzacıda \"Geç\" düğmesine basmadıkça önceki kimlikle sürer.";
    return {baslik: "Bot şu anda çalışıyor", metin: metin};
}

/** `soz` bitince ya da `ms` dolunca (hangisi önceyse) çözülür; asla reddetmez. */
function sureliBekle(soz: Promise<any>, ms: number): Promise<void> {
    return new Promise<void>((coz) => {
        const zamanlayici = setTimeout(coz, ms);
        const bitir = () => {
            clearTimeout(zamanlayici);
            coz();
        };
        soz.then(bitir, bitir);
    });
}

/**
 * Büro değişimine devam edilsin mi? Önce görev listesi tazelenir (en çok 2,5 sn; liste
 * başka sayfada hiç yüklenmemiş olabilir, hata yutulur), bot meşgul değilse doğrudan true;
 * meşgulse kullanıcıdan onay istenir.
 */
export async function buroDegistirmeyiOnayla(store: any, hedef: any, goster?: (secenek: any) => Promise<any>): Promise<boolean> {
    try {
        await sureliBekle(Promise.resolve(store.dispatch("updateTasks")), 2500);
    } catch (e) {
        // eldeki liste kullanılır
    }
    const botKimligi = store.getters.botKimligi || null;
    const mesgul = botMesgulMu({
        playerDurum: store.getters.getPlayerDurum,
        gorevler: store.getters.getGorevler,
        botKimligi: botKimligi
    });
    if (!mesgul) return true;

    const uyari = buroDegistirmeUyarisi({botKimligi: botKimligi, hedefBuro: String(hedef && hedef.title ? hedef.title : "")});
    const sonuc = await (goster || ((secenek: any) => _swal.fire(secenek)))({
        icon: "warning",
        title: uyari.baslik,
        text: uyari.metin,
        showCancelButton: true,
        confirmButtonText: "Yine de değiştir",
        cancelButtonText: "Vazgeç",
        reverseButtons: true
    });
    return !!(sonuc && sonuc.isConfirmed);
}
